import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch'; // Import catch operator correctly
import 'rxjs/add/observable/throw'; // Import throw method correctly
import { environment } from '../../.../../../environments/environment';
@Injectable()
export class professionalLocatorService {
  baseUrl: string = environment.baseUrl;
  private apiUrl = `${this.baseUrl}professional/getlatlong`;

  constructor(private http: HttpClient) { }

  getLatAndLong(location: any, professional): Observable<any> {
    const url = `${this.apiUrl}?location=${location}&ProfessionalType=${professional}`;
    return this.http.get(url).catch(this.handleError);  // Use catch operator correctly
  }

  private handleError(error: any): Observable<any> {
    let errorMessage = 'An unknown error occurred!';

    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }

    // Use Observable.throw to return the error message
    return Observable.throw(error["error"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/services/professional-locator.service.ts